define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitDoc = void 0;
    class PermitDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitDocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitDocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "LicenseStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Permit", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PermitDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Permit = parent;
            this.PermitId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Permit = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitId = (0, EntityUtil_1.toInt)(entity.PermitId);
            a.PermitDocType = (0, EntityUtil_1.toInt)(entity.PermitDocType);
            a.LicenseStatus = b.LicenseStatus;
            a.CreateDate = b.CreateDate;
            a.CreateUser = b.CreateUser;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PermitDoc.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "PermitId", "Permit Id");
                this.validateReqNumber(validationState, "PermitDocType", "Permit Document Type");
                this.validateReqString(validationState, "LicenseStatus", "License Status ");
                this.validateReqDate(validationState, "CreateDate", "Create Date");
                this.validateReqString(validationState, "CreateUser", "Create User");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitId: this.PermitId,
                PermitDocType: this.PermitDocType,
                LicenseStatus: this.LicenseStatus,
                CreateDate: this.CreateDate,
                CreateUser: this.CreateUser,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(p, permitDocumentType) {
            (0, EventManager_1.notify)("Creating Document");
            return new Promise((resolve, reject) => {
                services_1.SrmsServiceManager.Instance.PermitApplication.generatePermitReport(p.toJson(), permitDocumentType).then(d => {
                    let x = new PermitDoc(d, p);
                    p.PermitDoc.push(x);
                    resolve(x);
                });
            });
        }
    }
    exports.PermitDoc = PermitDoc;
    Object.defineProperty(PermitDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PermitDoc"
    });
    Object.defineProperty(PermitDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit Documents"
    });
    Object.defineProperty(PermitDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitId", "PermitDocType", "LicenseStatus", "CreateDate", "CreateUser"]
    });
    Object.defineProperty(PermitDoc, "PermitIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "PermitDocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "PermitDocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "LicenseStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(PermitDoc, "LicenseStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "LicenseStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "CreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitDoc, "CreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(PermitDoc, "CreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "PermitId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "PermitIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "PermitDocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "PermitDocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "LicenseStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "LicenseStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "CreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "CreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "CreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "CreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitDoc.prototype, "Permit", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitDoc.prototype, "merge", null);
});
